import React from 'react';
import { Dialog, DialogTitle, DialogActions, DialogContent } from '@mui/material';
import { DialogProps } from '@mui/material/Dialog';

const CustomDialog = (props: DialogProps) => {
    const { onClose } = props;
    return (
        <Dialog
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose && onClose(event, reason);
                }
            }}
            disableEnforceFocus
            {...props}
        />
    );
};

export { Dialog, CustomDialog, DialogTitle, DialogActions, DialogContent };
